"use strict";
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.LinkMenuItemDefinition = exports.LinkMenuItem = void 0;
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var LinkMenuItem = function (_a) {
    var item = _a.item, path = _a.path, state = _a.state, dispatch = _a.dispatch, navigate = _a.navigate;
    var isCurrent = state.activePath === path;
    var isActive = state.activePath.startsWith(path);
    var isInSubMenu = path.split('.').length > 2;
    var onClick = function (e) {
        // Do not capture click events with modifier keys or non-main buttons.
        if (e.ctrlKey ||
            e.shiftKey ||
            e.metaKey ||
            (e.button && e.button !== 0)) {
            return;
        }
        e.preventDefault();
        navigate(item.url).then(function () {
            // Set active menu item
            dispatch({
                type: 'set-active-path',
                path: path,
            });
            // Reset navigation path to close any open submenus
            dispatch({
                type: 'set-navigation-path',
                path: '',
            });
        });
    };
    var className = ('sidebar-menu-item'
        + (isActive ? ' sidebar-menu-item--active' : '')
        + (isInSubMenu ? ' sidebar-menu-item--in-sub-menu' : ''));
    return (React.createElement("li", { className: className },
        React.createElement("a", { href: item.url, "aria-current": isCurrent ? 'page' : undefined, onClick: onClick, className: "sidebar-menu-item__link " + item.classNames },
            item.iconName && React.createElement(Icon_1["default"], { name: item.iconName, className: "icon--menuitem" }),
            React.createElement("span", { className: "menuitem-label" }, item.label))));
};
exports.LinkMenuItem = LinkMenuItem;
var LinkMenuItemDefinition = /** @class */ (function () {
    function LinkMenuItemDefinition(_a) {
        var name = _a.name, label = _a.label, url = _a.url, _b = _a.icon_name, iconName = _b === void 0 ? null : _b, _c = _a.classnames, classnames = _c === void 0 ? undefined : _c;
        this.name = name;
        this.label = label;
        this.url = url;
        this.iconName = iconName;
        this.classNames = classnames;
    }
    LinkMenuItemDefinition.prototype.render = function (_a) {
        var path = _a.path, state = _a.state, dispatch = _a.dispatch, navigate = _a.navigate;
        return (React.createElement(exports.LinkMenuItem, { key: this.name, item: this, path: path, state: state, dispatch: dispatch, navigate: navigate }));
    };
    return LinkMenuItemDefinition;
}());
exports.LinkMenuItemDefinition = LinkMenuItemDefinition;
